<template>
    <section class="container-ticket-reserve">
        <div>
            <svg width="354" height="231" viewBox="0 0 354 231" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 9.64413L10.1893 0L19.4522 9.64413L29.024 0L39.2133 9.64413L48.785 0L58.9743 9.64413L69.1635 0L78.7353 9.64413L88.7702 0L98.1875 10.1034L108.068 0L118.103 10.1034L128.91 0L138.173 10.1034L147.744 0L157.625 10.1034L167.66 0L177.232 10.1034L188.038 0L197.301 10.1034L207.336 0L216.445 10.1034L227.252 0L236.051 10.1034L245.932 0L255.967 10.1034L265.693 0L274.956 10.1034L284.991 0L295.334 10.1034L305.678 0L314.941 9.64413L325.13 0L334.393 10.1034L344.428 0L354 9.64413V221.356L344.119 231L334.548 222.045L324.976 231L315.095 222.045L305.524 231L295.334 222.045L284.682 231L275.419 222.045L265.693 231L255.812 222.045L245.932 231L236.515 222.045L226.48 231L217.371 222.045L207.027 231L197.456 222.045L188.656 231L177.54 222.045L167.197 231L157.471 222.045L147.59 231L138.018 222.045L128.601 231L118.412 222.045L108.222 231L98.4963 222.045L88.9246 230.77L78.7353 222.045L69.1635 230.77L59.1287 221.585L48.785 231L39.2133 222.045L29.4871 230.77L19.761 221.585L9.88051 230.541L0 221.585V9.64413Z" fill="white"/>
            </svg>

            <div class="data-reserve-client">
                <div class="reserve-client">
                    Reserva #{{data.id}}
                    <i v-if="isActiveProposal" class="fal fa-check circle-check" />
                </div>

                <div class="data-batch">
                    <div class="number-batch">{{data.units.number}}</div>

                    <span class="batch">{{ unitInfos(data.units) }}</span>
                </div>

                <div class="data-expires">
                    <em class="fal fa-clock" />

                    <span class="expires">
                        Expira em {{ expirationTime }}
                    </span>
                </div>

                <div v-if="$route.name !== 'launch.control.validation'" class="cog">
                    <ui-menu-card icon="fal fa-cog">
                        <button :disabled="load" @click="printHandler">Imprimir Comprovante</button>
                        <button
                            v-if="showActivateSimulation"
                            :loading="load"
                            @click="enableSimulationHandler">
                            Ativar Simulação
                        </button>
                        <button :disabled="load" @click="cancelHandler">Cancelar Reserva</button>
                    </ui-menu-card>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { uiMenuCard } from "@/components/ui"

    import { simulation } from '@/services/axios'
    import { currencyBRL } from '@/filters'

    import { mapActions, mapGetters } from 'vuex'

    const moment = require('moment')
	require('moment/locale/pt-br')

    export default {
        name: "ui-ticket-reserve",

        components: {
            uiMenuCard,
        },

        filters: { currencyBRL },

        props: {
            /**
             * Dados da reserva a ser mostrada
             */
            data: {
                type: Object,
                required: true
            },
            /**
             * Dados da disponibilidade à qual a reserva pertence
             */
            availability: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                load: false
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                control: 'getControl'
            }),
            /**
             * Computed property que formata e retorna a data de expiração da reserva atual
             */
            expirationTime() {
                const timeToExpire = moment.duration(this.data.expire_time)

				return `${timeToExpire.days()} dia(s), ` +
                    `${timeToExpire.hours()} hora(s) e ` +
                    `${timeToExpire.minutes()} minuto(s)`
            },
            /**
             * Computed property que define se a reserva atual está vinculada à proposta ativa
             * do cliente/negócio selecionado
             */
            isActiveProposal() {
                return this.control.deal.simulation &&
                    this.control.deal.simulation.unity_id === this.data.units.id
            },
            /**
             * Computed property que define se a opção de ativar simulação será mostrada ou não
             * para a reserva
             */
            showActivateSimulation() {
                return !this.isActiveProposal &&
                    this.data.simulation &&
                    this.$route.name === 'launch.control.payment'
            }
        },

        methods: {
            ...mapActions('launchDay', ['loadControlDeal']),
            /**
             * Retorna as informações formatadas da unidade reservada
             */
            unitInfos(unit) {
                let formatted = this.availability.type === 'horizontal'
                    ? `Quadra ${unit.block} - Lote ${unit.number}`
                    : `Torre ${unit.block} - Andar ${unit.floor} - Unidade ${unit.number}`
                formatted += ` - ${unit.area} m² - ${this.$options.filters.currencyBRL(unit.cost)}`

                return formatted
            },
            /**
             * Event handler que trata o evento de quando o cancelamento de uma reserva é requerido
             */
            cancelHandler() {
                this.$root.$emit('modal-open-cancel-reservation', this.data)
            },
            /**
             * Event handler que trata o evento de quando a impressão do conprovante
             * da reserva é requerida
             */
            printHandler() {
                const payload = {
                    reserves: [this.data],
                    availability: { ...this.availability }
                }
                this.$root.$emit('print-reserve-voucher', payload)
            },
            /**
             * Event handler que trata o evento de quando uma 
             */
            enableSimulationHandler() {
                this.load = true
                simulation.create(this.data.simulation.id, {})
                    .then(response => {
                        if (response.data && response.data.msg) this.$toastr.s(response.data.msg)
                        this.loadControlDeal({ code: this.data.deal_id, type: 'cod' })
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.load = false
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>